export default "__VITE_ASSET__sBxrgOA4__"